module.exports = __webpack_public_path__ + "img/bg.63c5154f.png";